// external libs
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

import moment from '../Moment'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
	onChangeError: ['error'],
	onChangeErrorRequest: ['error'],
	onChangeValidationError: ['name', 'error'],
	onSetFetching: ['fetching'],
	onStartFetching: null,
	onStopFetching: null,
	onGetOperatingHoursRequest: ['data'],
	onGetOperatingHoursRequestSuccess: ['operatingHours'],
	onSendCallbackRequest: ['data', 'labels', 'callbackType'],
	onSendCallbackRequestSuccess: ['data', 'callbackType'],
	sendMailRequest: ['data'],
	sendMailRequestSuccess: ['sendMail'],
	getSettingsRequest: null,
	getSettingsRequestSuccess: ['settings'],
	toggleConfirmModal: ['confirmOpenModal'],
})

export const GeneralTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({ // eslint-disable-line
	confirmOpenModal: false,
	crmCallbackData: {},
	error: {},
	fetching: false,
	operatingHours: { timeTo: {}, timeFrom: {} },
	sendMail: {},
	validationErrors: {},
})

/* ------------- Reducers ------------- */

export const setState = (state, key, value) =>
	state.setIn([key], value)

export const changeError = (state, { error }) =>
	state.merge({ error })

export const changeErrorRequest = (state, { error }) =>
	state.merge({ error, fetching: false })


/*	export const changeValidationError = (state, { name, error }) =>
	state.merge({ validationErrors: {...state.validationErrors, [name]: error}  })
*/
export const changeValidationError = (state, { name, error }) => {
	const validationErrors = { ...state.validationErrors }
	validationErrors[name] = error
	return state.merge({ validationErrors })
}

export const onGetOperatingHoursRequestSuccessR = (state, { operatingHours }) =>
	state.merge({
		operatingHours: { timeTo: operatingHours.timeTo, timeFrom: operatingHours.timeFrom }
	})

export const sendMailSuccess = (state, { mail }) =>
	state.merge({
		sendMail: mail,
	})

export const onSendCallbackRequestSuccessR = (state, { crmCallbackData }) =>
	state.merge({
		crmCallbackData: crmCallbackData,
	})

const toggleConfirmModalR = (state, { confirmOpenModal }) =>
	state.set('confirmOpenModal', confirmOpenModal)

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
	[Types.ON_CHANGE_ERROR]: changeError,
	[Types.ON_SET_FETCHING]: (state, { fetching }) => setState(state, 'fetching', fetching),
	[Types.ON_START_FETCHING]: state => setState(state, 'fetching', true),
	[Types.ON_STOP_FETCHING]: state => setState(state, 'fetching', false),
	[Types.ON_CHANGE_VALIDATION_ERROR]: changeValidationError,
	[Types.ON_CHANGE_ERROR_REQUEST]: changeErrorRequest,
	[Types.ON_GET_OPERATING_HOURS_REQUEST_SUCCESS]: onGetOperatingHoursRequestSuccessR,
	[Types.ON_GET_OPERATING_HOURS_REQUEST]: state => state,
	[Types.ON_SEND_CALLBACK_REQUEST_SUCCESS]: onSendCallbackRequestSuccessR,
	[Types.ON_SEND_CALLBACK_REQUEST]: state => state,
	[Types.SEND_MAIL_REQUEST_SUCCESS]: sendMailSuccess,
	[Types.SEND_MAIL_REQUEST]: state => state,
	[Types.GET_SETTINGS_REQUEST]: state => state,
	[Types.GET_SETTINGS_REQUEST_SUCCESS]: state => state,
	[Types.TOGGLE_CONFIRM_MODAL]: toggleConfirmModalR,
})

